import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import TransferPage from './pages/TransferPage';
import WirePage from './pages/WirePage';
import BillPayPage from './pages/BillPayPage';
import ZellePage from './pages/ZellePage';
import CardsPage from './pages/CardsPage';
import SocialSecurityPage from './pages/SocialSecurityPage';
import FXRatesPage from './pages/FXRatesPage';
import TransactionsPage from './pages/TransactionsPage';
import AccountsPage from './pages/AccountsPage';
import ExternalAccountsPage from './pages/ExternalAccountsPage';
import SettingsPage from './pages/SettingsPage';
import AppLayout from './components/AppLayout';
import './App.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen"><div className="skeleton-pulse w-8 h-8 bg-primary rounded-full" /></div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
      <Route path="/register" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <RegisterPage />} />
      <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="transfer" element={<TransferPage />} />
        <Route path="wire" element={<WirePage />} />
        <Route path="bill-pay" element={<BillPayPage />} />
        <Route path="zelle" element={<ZellePage />} />
        <Route path="cards" element={<CardsPage />} />
        <Route path="social-security" element={<SocialSecurityPage />} />
        <Route path="fx-rates" element={<FXRatesPage />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="external-accounts" element={<ExternalAccountsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </Router>
    </AuthProvider>
  );
}

export default App;
